import type { ComponentProps, ReactNode } from 'react';
import { Button, Inline, Spinner } from '@kanbios/ui';

/**
 * États transverses « Action courte en cours »: while the API answers, the button
 * shows the DSM Spinner (« a short, unknown wait on a button ») in place of its
 * icon, is disabled and keeps its label.
 */
export function PendingButton({ pending, icon, disabled, children, ...rest }: ComponentProps<typeof Button> & { pending: boolean }) {
  return (
    <Button {...rest} icon={pending ? undefined : icon} disabled={disabled || pending} aria-busy={pending || undefined}>
      {pending ? <Spinner size={16} /> : null}
      {children}
    </Button>
  );
}

/** The same for a DSM Dialog's confirm button (its `confirmLabel` takes content). */
export function pendingLabel(label: ReactNode, pending: boolean): ReactNode {
  return pending ? <Inline gap={8} align="center"><Spinner size={16} />{label}</Inline> : label;
}
